"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import { Spinner } from "@/components/ui/spinner";

export interface LoadingSpinnerProps extends React.ComponentProps<
  typeof Spinner
> {
  label?: string;
  wrapperClassName?: string;
}

export function LoadingSpinner({
  label,
  wrapperClassName,
  ...props
}: LoadingSpinnerProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center",
        wrapperClassName
      )}
      role={label ? "status" : undefined}
      aria-label={label}
    >
      <Spinner {...props} />
    </span>
  );
}

export default LoadingSpinner;
